<template>
  <va-modal
    id="downloadStatsExcelModal"
    ref="downloadStatsExcelModal"
    :value="isOpen"
    :cancelText="$t('modals.buttons.cancel')"
    :okText="$t('dashboard_new_evollu.download_excel')"
    @ok="onSubmit"
    @cancel="onCancel"
    size="large"
    :noOutsideDismiss="true"
    :okToClose="false"
  >
    <div slot="header" class="modal-title">
      <span> Exportar Estatísticas </span>
    </div>

    <form class="evollu-form">

      <div class="row col-12 justify-content-center">
        <h4>Selecione o período para exportação das estatísticas de {{exportType === 'audiologists' ? 'audiologistas' : 'dispensers'}}</h4>
        <div class="col-6 mt-3 mb-5">
          <label class="form-label">{{$t('statistics2.hear.sublabels.period')}}</label>
          <multiselect
            v-model="selectedMonth"
            :options="monthsOptions"
            track-by="id"
            label="value"
            select-label=""
            selected-label=""
            deselect-label=""
            placeholder="---"
            :allow-empty="false"
            :multiple="false"
            :searchable="true"
          >
          </multiselect>
        </div>
      </div>
    </form>


  </va-modal>
</template>

<script>
import Multiselect from 'vue-multiselect';
import moment from 'moment';
import { StatisticsService } from '@/api/VirtualWaitingRoomService';

export default {
  components: { Multiselect },
  props: {
    exportType: {
      type: String,
      required: true
    }
  },
  mounted: function() {
    this.isOpen = true;
    this.selectedMonth = this.monthsOptions.find(month => month.id === parseInt(moment().subtract(1, 'month').format('M')))
  },
  data: function() {
    return {
      isOpen: false,
      selectedMonth: null,
      monthsOptions: [
        {id: 1, value: 'Janeiro'},
        {id: 2, value: 'Fevereiro'},
        {id: 3, value: 'Março'},
        {id: 4, value: 'Abril'},
        {id: 5, value: 'Maio'},
        {id: 6, value: 'Junho'},
        {id: 7, value: 'Julho'},
        {id: 8, value: 'Agosto'},
        {id: 9, value: 'Setembro'},
        {id: 10, value: 'Outubro'},
        {id: 11, value: 'Novembro'},
        {id: 12, value: 'Dezembro'}
      ]
    }
  },
  methods: {
    onSubmit() {
      let params = {
        month: this.selectedMonth.id,
        exportType: this.exportType
      }

      this.isExportingExcelToast = this.showToast(this.$t('biosigns.accessCodes.exporting'), {
        ...this.$store.state.successToastOptions,
        icon: 'cloud-download',
        duration: null
      })

      StatisticsService.downloadStatsExcel(params).then((res) => {
        const url = window.URL.createObjectURL(new Blob([res.data]))
        const link = document.createElement('a')
        link.href = url
        const fileName = this.exportType === 'audiologists' ? `estatisticas_audiologistas_${this.selectedMonth.value.toLowerCase()}.xlsx` : `estatisticas_dispensers_${this.selectedMonth.value.toLowerCase()}.xlsx`
        link.setAttribute('download', fileName)
        document.body.appendChild(link)
        link.click()
        this.isExportingExcelToast.goAway(100)
      }).catch(err => {
        console.log(err)
        this.isExportingExcelToast.goAway(100)
        setTimeout(() => {
          this.showToast(this.$t('statistics2.ops_stats.downloadExcelGenericFailure'), this.$store.state.errorToastOptions)
        }, 500)
      }).finally(() =>{
        this.isExportingExcelToast = null
        this.onCancel()
      })


    },
    onCancel: function () {
      this.isOpen = false
      setTimeout(() => {
        this.$emit('modalClosed')
      }, 250)
    }
  }
}

</script>

<style scoped lang="scss">

</style>
